export default __webpack_public_path__ + "static/media/oleo.ca1e8357.svg";